import * as React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

interface IconButtonProps {
	trigger?: []
	tooltipText?: string
	onClick?: () => void
	icon: string
}

const IconButton: React.SFC<IconButtonProps> = (props) => {
	const style = props.onClick
		? {
				cursor: 'pointer',
		  }
		: {}

	const icon = (
		<span style={style} onClick={props.onClick}>
			<i className={`fas ${props.icon}`} />
		</span>
	)
	return !!props.tooltipText ? (
		<OverlayTrigger
			trigger={['hover', 'focus']}
			placement="bottom"
			overlay={<Tooltip id={'link'}>{props.tooltipText}</Tooltip>}
		>
			{icon}
		</OverlayTrigger>
	) : (
		icon
	)
}

export default IconButton
